// extracted by mini-css-extract-plugin
export default {"grid":"grid__nJatXzWI","pill":"pill__bcNnZ2Xp","activePill":"activePill__KWxNmF1e","lastSeen":"lastSeen__XQIhuJjU","skeleton":"skeleton__wtIYEV5X"};